import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import img1 from '../assets/images/img1.jpeg'
import img2 from '../assets/images/img2.jpeg'
import img3 from '../assets/images/img3.jpeg'
import img4 from '../assets/images/img4.jpeg'


const Services = () => {
  const options = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000, // Adjust autoplay speed
    autoplayHoverPause: true,
    margin: 10,
    nav: false, // Disable navigation arrows
    dots: false, // Disable pagination dots
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 4 }, // Show 4 items on large screens
    },
  };

  return (
    <div id="Services">
      <section className="service sec-padd2">
        <div className="container">
          <div className="section-title">
            <h2>Our Services</h2>
          </div>

          <OwlCarousel className="owl-theme" {...options}>
            <article className="single-column">
              <div className="item bg-white">
                <figure className="image-box">
                  <img 
                    src={img1} 
                    alt="Talent Acquisition & Staffing" 
                    style={{height:'200px'}}
                  />
                </figure>
                <div className="content center">
                  <h5>Service #1</h5>
                  <h4>Talent Acquisition & Staffing</h4>
                  <p>We help businesses find the right talent for open positions by providing carefully selected profiles that match specific job requirements. Our tailored recruitment process ensures that you have the right people for every role.</p>
                </div>
              </div>
            </article>

            <article className="single-column">
              <div className="item bg-white">
                <figure className="image-box" >
                  <img 
                    src={img2} 
                    alt="Training & Skill Development" 
                    style={{height:'200px'}}
                  />
                </figure>
                <div className="content center">
                  <h5>Service #2</h5>
                  <h4>Training & Skill Development</h4>
                  <p>Empower your team by providing training that enhances their existing skills and introduces new ones. We offer customized programs designed to keep your workforce at the forefront of industry standards and technological advancements.</p>
                </div>
              </div>
            </article>

            <article className="single-column">
              <div className="item bg-white">
                <figure className="image-box">
                  <img 
                    src={img3} 
                    alt="Technical Support & Troubleshooting" 
                    style={{height:'200px'}}
                  />
                </figure>
                <div className="content center">
                  <h5>Service #3</h5>
                  <h4>Technical Support & Troubleshooting</h4>
                  <p>Our dedicated technical support team identifies and resolves software issues, ensuring minimal disruption to your operations. We provide prompt solutions, helping you maintain a smooth and efficient workflow.</p>
                </div>
              </div>
            </article>

            <article className="single-column">
              <div className="item bg-white">
                <figure className="image-box">
                  <img 
                    src={img4} 
                    alt="IT Strategy Consulting" 
                    style={{height:'200px'}}
                  />
                </figure>
                <div className="content center">
                  <h5>Service #4</h5>
                  <h4>IT Strategy Consulting</h4>
                  <p>Develop a clear IT roadmap that aligns with your business objectives. Our expert consultants analyze your needs and offer strategic guidance to help you leverage technology to drive growth and achieve long-term success.</p>
                </div>
              </div>
            </article>
          </OwlCarousel>
        </div>
      </section>
    </div>
  );
};

export default Services;
